  <template>
  <div class="app-layout">
    <AppSidebar :collapsed="appStore.sidebarCollapsed" />
    <div class="app-layout__main">
      <AppHeader />
      <main class="app-layout__content">
        <RouterView />
      </main>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppHeader from './components/AppHeader.vue'
import AppSidebar from './components/AppSidebar.vue'
import { useAppStore } from '@/stores/app'
const appStore = useAppStore()
</script>

<style scoped lang="scss">
.app-layout { min-height: 100vh; display: flex; background: var(--jf-color-background); }
.app-layout__main { min-width: 0; flex: 1; display: flex; flex-direction: column; }
.app-layout__content { flex: 1; padding: 20px 24px 32px; overflow-x: hidden; overflow-y: auto; }
</style>
